import React  from 'react'
import DropDown from '../dropdown';
import PropTypes from "prop-types";
//import { Products } from '../../../api/services/next';
import { GetProducts } from '../../../api/services/pms';

const ProductsDropDown = ({HotelID, ...rest}) => {
    const itemClassName = React.useCallback(item => {
        return item.IsProductRestricted ? "restricted":null
    }, [])

    //return <DropDown search api={Products.GetProducts} spec={{HotelID}} textField="Name" itemClassName={itemClassName} valueField="Id" {...rest} />
    return <DropDown search api={GetProducts} spec={{HotelID}} textField="ProductName" itemClassName={itemClassName} valueField="Id" {...rest} />
}

ProductsDropDown.propTypes = {
    HotelID: PropTypes.any
}

export default ProductsDropDown
